import { Routes, Route, useLocation } from "react-router-dom"
import { useState, useEffect, Fragment } from "react";

import { Header } from "./components/Header/Header.js";
import { Footer } from "./components/Footer/Footer.js";
import { Main } from "./components/Main/Main.js";
import { LangContext } from "./contexts/Language.js";
import { StickyPhone } from "./components/StickyPhone/StickyPhone.js";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      let attempts = 0;
      const tryScroll = () => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else if (attempts < 20) {
          attempts++;
          setTimeout(tryScroll, 100);
        }
      };
      tryScroll();
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'BG');

  useEffect(() => {
    localStorage.setItem('lang', lang);
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      <Fragment>
        <ScrollToTop />
        <Header />

        <Main />

        <Footer />
        <StickyPhone />
      </Fragment>
    </LangContext.Provider>
  );
}

export default App;
